import { render, staticRenderFns } from "./fcGoods.vue?vue&type=template&id=d0ad3396&"
import script from "./fcGoods.vue?vue&type=script&lang=js&"
export * from "./fcGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports